module.exports = __webpack_public_path__ + "static/iStock_000039752072_Full.e31ea0fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/iStock_000039752072_Full.jpg
// module id = 85
// module chunks = 35783957827783 208176855801404 269829036549620